import React from 'react'
import PropTypes from 'prop-types'

import CardImage from 'Catalog/Service/ServiceCard/CardImage'
import CardTitle from 'Catalog/Service/ServiceCard/CardTitle'
import CardInternal from 'Catalog/Service/ServiceCard/CardInternal'
import CardButton from 'Catalog/Service/ServiceCard/CardButton'
import IsResponsiveEnabledContext from 'Shared/IsResponsiveEnabledContext'
import { Link } from 'react-router-dom'

const ServiceCard = ({
  path,
  image,
  name,
  className,
  isResponsiveEnabled
}) => (
  <IsResponsiveEnabledContext.Provider value={isResponsiveEnabled}>
    <div className={`item card card-service ${className}`}>
      <div className='bordered radius border-color-ui-3 bg-white product-image'>
        <Link to={path} aria-label={name} className='px-1 d-block'>
          <div className='row mx-0 px-1'>
            <CardImage
              linkTo={path}
              imageUrl={image}
              altText={name}
            />
            <CardInternal>
              <CardTitle linkTo={path} title={name} />
              <CardButton text={'Trocar reales'} />
            </CardInternal>
          </div>
        </Link>
      </div>
    </div>
  </IsResponsiveEnabledContext.Provider>
)

ServiceCard.propTypes = {
  path: PropTypes.string.isRequired,
  name: PropTypes.string,
  image: PropTypes.string,
  className: PropTypes.string,
  isResponsiveEnabled: PropTypes.bool
}

export default ServiceCard



// WEBPACK FOOTER //
// ./src/Catalog/Service/ServiceCard/ServiceCard.js